const getWishlist = state => (state && state.wishlist) || {};

const isLoading = state => getWishlist(state).loading;
const getData = state => getWishlist(state).data || {};
const getSharedData = state => getWishlist(state).sharedData || {};
const getWishlistCode = state => getData(state).code;
const getWishlistName = state => getData(state).name;
const getSharedWishlistName = state => getSharedData(state).name;
const getSharedWishlistOwnerName = state => getSharedData(state).ownerName;
const getSharedWishlistCode = state => getSharedData(state).code;
const getSharedWishlistToken = state => getSharedData(state).sharedWishlistToken;
const getErrorStateForSharedWishlist = state => getWishlist(state).isErrorStateForSharedWishlist;
const getEntries = state => getData(state).entries || [];
const getEntry = (state, productCode) =>
    getEntries(state)
        .filter(entry => entry.product.code === productCode)
        .pop();
const getSharedEntries = state => getSharedData(state).entries || [];
const getSharedEntry = (state, productCode) =>
    getSharedEntries(state)
        .filter(sharedEntry => sharedEntry.product.code === productCode)
        .pop();
const getEGiftCardEntry = state =>
    getEntries(state).find(entry => entry.product && !!entry.product.egiftCard);
const getProducts = state => getEntries(state).map(e => e.product);
const getProductCodes = state => getProducts(state).map(p => p.code);
const getActiveFilterName = state => getWishlist(state).activeFilter.name;
const getAviableFilters = state => getWishlist(state).aviableFilters;
const getNewWishlistName = state => getWishlist(state).newWishlistName;
const isNewListNameValid = state => getWishlist(state).isNewListNameValid;
const getPendingProduct = state => getWishlist(state).pendingProduct;
const getFullyAddedProductList = state => getWishlist(state).fullyAdded || [];
const getNewWishlistAnalysticsData = state => getWishlist(state).newWishlistAnalystics || {};
const getErrorWhileAddToWishlist = state => getWishlist(state).errorWhileAddToWishlist || false;

export default {
    isLoading,
    getData,
    getWishlistCode,
    getSharedWishlistCode,
    getSharedWishlistToken,
    getWishlistName,
    getNewWishlistName,
    isNewListNameValid,
    getSharedWishlistName,
    getSharedWishlistOwnerName,
    getProductCodes,
    getEntries,
    getSharedEntries,
    getEntry,
    getEGiftCardEntry,
    getSharedEntry,
    getActiveFilterName,
    getAviableFilters,
    getPendingProduct,
    getFullyAddedProductList,
    getNewWishlistAnalysticsData,
    getErrorWhileAddToWishlist,
    getErrorStateForSharedWishlist,
};
